import { Spinner } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import { IJsonQueryDistrict } from '../../../../api-models/common/json_query';
import { TLocation } from 'shared/types/location';

import style from './index.css';
import { IGeoDistrict } from 'shared/types/geo/districts';
import { DistrictsLayout, isMoscowLocation } from './layout';
import { MoscowDistrictsHeader } from './header';

export interface IDistrictsV2Props {
  isDataLoading: boolean;
  districts: IGeoDistrict[] | undefined;
  selectedLocation: TLocation;
  selectedDistricts: IJsonQueryDistrict[];
  includeNewMoscow: boolean | null;
  isRedesign?: boolean;
  onSelected(id: number, name: string): void;
  onNewMoscowSwitched(includeNewMoscow: boolean | null): void;
  onRemoved(id: number): void;
}

export class DistrictsV2 extends React.Component<IDistrictsV2Props> {
  public render() {
    return (
      <>
        {isMoscowLocation(this.props.selectedLocation) && (
          <MoscowDistrictsHeader
            isRedesign={this.props.isRedesign}
            includeNewMoscow={this.props.includeNewMoscow}
            onNewMoscowSwitched={this.props.onNewMoscowSwitched}
          />
        )}
        <div>
          {this.props.isDataLoading && (
            <div className={style['preloader-wrapper']}>
              <Spinner size={50} />
            </div>
          )}
          {this.props.districts && this.renderDistricts(this.props.districts)}
        </div>
      </>
    );
  }

  private renderDistricts(districts: IGeoDistrict[]) {
    return (
      <div className={clsx(this.props.isRedesign ? style['districts-redesign'] : style.districts)}>
        <DistrictsLayout
          areas={districts}
          selectedLocation={this.props.selectedLocation}
          selectedDistricts={this.props.selectedDistricts}
          onSelected={this.props.onSelected}
          onRemoved={this.props.onRemoved}
        />
      </div>
    );
  }
}
